export default __webpack_public_path__ + "static/media/remove.510f4cbc.png";